var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.$style.svg,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.viewBox,"height":_vm.size,"width":_vm.size}},[_c('path',{attrs:{"d":_vm.path}})])}
var staticRenderFns = []

export { render, staticRenderFns }